import React, { useContext } from 'react';
import {
  INTL_MARKETS,
  useConditionalFeature,
} from '@americanexpress/conditional-features';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { RenderModule } from 'holocron';
import {
  getDates, getEndTime, getStartTime,
} from '../../selectors/requestSelectors';
import { getIsErrorByField } from '../../selectors/validationSelectors';
import { getBundleType } from '../../selectors/filtersSelectors';
import clearInvalidPartialDatesThunk from '../../thunks/clearInvalidPartialDatesThunk';
import { setEndTimeAction, setStartTimeAction } from '../../ducks/requestDuck';
import { getMinAdvanceDate } from '../../utils/dateUtils';
import themeContext from '../../context/themeContext';
import packageContext from '../../context/packageContext';
import { getMarketConfigDefaultTime } from '../../selectors/marketConfigSelector';
import { BUNDLE_TYPES } from '../../constants/packagesConstants';

const PackagesDateRange = () => {
  const isStartDateWarning = useSelector(getIsErrorByField('startDate'));
  const isEndDateWarning = useSelector(getIsErrorByField('endDate'));
  const dateValues = useSelector(getDates);
  const startTimeValue = useSelector(getStartTime);
  const endTimeValue = useSelector(getEndTime);
  const bundleType = useSelector(getBundleType);
  const defaultTime = useSelector(getMarketConfigDefaultTime);
  const hasTimeDropdown = useConditionalFeature(INTL_MARKETS);
  const { formatMessage } = useIntl();

  const dispatch = useDispatch();
  const onChange = ({
    startDate,
    endDate,
    startTime,
    endTime,
  }) => {
    if (startDate !== dateValues.startDate || endDate !== dateValues.endDate) {
      dispatch(clearInvalidPartialDatesThunk({
        startDate,
        endDate,
      }));
    }

    if (hasTimeDropdown) {
      if (startTime !== startTimeValue) {
        dispatch(setStartTimeAction(startTime));
      }

      if (endTime !== endTimeValue) {
        dispatch(setEndTimeAction(endTime));
      }
    }
  };
  const {
    config: {
      minDays,
      minDaysAirCar,
      maxDays,
      maxAdvanceBooking,
      ...restOfMarketConfig
    },
  } = React.useContext(packageContext);

  const datePickerProps = {
    isDateRange: true,
    value: {
      ...dateValues,
      startTime: startTimeValue,
      endTime: endTimeValue,
    },
    onChange,
    placeholder: {
      startDate: formatMessage({ id: 'depart' }),
      endDate: formatMessage({ id: 'return' }),
    },
    maxNights: maxDays,
    maxDaysAdvanceFromToday: maxAdvanceBooking,
    minNights: bundleType === BUNDLE_TYPES.AIR_CAR ? minDaysAirCar : minDays,
    minStartDate: getMinAdvanceDate(bundleType, restOfMarketConfig),
    theme: useContext(themeContext),
    hasTimeDropdown,
    defaultTime,
    warnings: {
      isStartDateWarning,
      isEndDateWarning,
    },
  };

  return (
    <div
      className={clsx('pad-0-r pad-b-sm-down col-xs-12', {
        'col-md-5 col-xl-4': hasTimeDropdown,
        'col-md-4 col-xl-3': !hasTimeDropdown,
      })}
      data-testid="packagesDateRange"
    >
      <RenderModule
        moduleName="axp-travel-search-date-picker"
        props={{
          id: 'packagesStartDate',
          version: '2',
          ...datePickerProps,
        }}
      />
    </div>
  );
};

export default PackagesDateRange;
